import React from "react";
import Balancer from "react-wrap-balancer";
import { Text, Flex, type TextProps, type FlexProps } from "@chakra-ui/react";

type SectionHeadingProps = {
  textAlign?: "center" | "left" | "right";
  textStyle?: "md" | "lg";
  eyebrow?: string;
  eyebrowColor?: TextProps["color"];
  title: string;
  titleElement?: "h2" | "h3";
  description?: string;
} & Omit<FlexProps, "textAlign">;

export function SectionHeading({
  titleElement = "h2",
  textAlign = "center",
  textStyle = "lg",
  eyebrow,
  eyebrowColor = "text.primary",
  title,
  description,
  ...props
}: SectionHeadingProps) {
  let align = "center";
  if (textAlign === "left") {
    align = "start";
  } else if (textAlign === "right") {
    align = "end";
  }

  return (
    <Flex direction="column" justify="center" align={align} textAlign={textAlign} {...props}>
      {eyebrow && (
        <Text fontSize={{ base: "xs", sm: "sm", lg: "md" }} textStyle="uppercase" color={eyebrowColor} mb={4}>
          {eyebrow}
        </Text>
      )}

      <Text as={titleElement} textStyle={textStyle === "lg" ? "h4" : "e3"} whiteSpace="pre-wrap">
        <Balancer>{title}</Balancer>
      </Text>

      {description && (
        <Text fontSize={textStyle} mt={5} w="100%" whiteSpace="pre-wrap">
          <Balancer ratio={0.65}>{description}</Balancer>
        </Text>
      )}
    </Flex>
  );
}
